module.exports = __webpack_public_path__ + "static/img/phone-CO.563a332.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phone-CO.png
// module id = cumg
// module chunks = 1